import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../lib/api-client';
import { getAttemptToken } from '../../lib/attempt-token';

/** Load a KNM illustration through the attempt-scoped API, never a public asset URL. */
export const AttemptQuestionImage: React.FC<{
  attemptId: string;
  questionId: string;
  theme?: string;
}> = ({ attemptId, questionId, theme }) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    setUrl(null);
    setFailed(false);
    const token = getAttemptToken(attemptId);
    apiClient.get<Blob>(`/exams/attempts/${attemptId}/question-image/${questionId}`, {
      responseType: 'blob',
      ...(token ? { headers: { 'x-attempt-token': token } } : {}),
    }).then((response) => {
      if (cancelled) return;
      objectUrl = URL.createObjectURL(response.data);
      setUrl(objectUrl);
    }).catch(() => {
      if (!cancelled) setFailed(true);
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attemptId, questionId]);

  if (failed) return <p className="text-sm text-error">{t('knm.imageUnavailable')}</p>;
  if (!url) return <p className="text-sm text-slate-500">{t('knm.imageLoading')}</p>;
  return <img src={url} alt={t('knm.imageAlt', { theme: theme || t('knm.subject') })} className="mb-5 max-h-56 w-full rounded-xl border border-slate-200 object-contain" />;
};
